/* eslint-disable max-len */
/* eslint-disable no-unused-expressions */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-param-reassign */
/* eslint-disable vars-on-top */
/* eslint-disable no-var */
/* eslint-disable no-redeclare */
/* eslint-disable camelcase */
/* eslint-disable import/order */
/* eslint-disable no-use-before-define */
/* eslint-disable react/no-this-in-sfc */
/* eslint-disable prefer-rest-params */
/* eslint-disable func-names */
/* eslint-disable import/no-unresolved */
import React, { useCallback } from 'react';
import _ from 'lodash';
import {
    ModalNextProvider,
    Button,
    ModalNext,
    ModalHeader,
    ModalBody,
    ModalFooter
} from '@jutro/components';
import PropTypes from 'prop-types';
import { LocaleService } from '@jutro/locale';
import { useAuthentication } from 'gw-digital-auth-react';
import styles from './piq-modal.module.scss';
import UtilService from '../../services/UtilService';

function PIQModalPopup(props) {
    const {
        isOpen,
        onResolve,
        modalTitle,
        modalDescription,
        leaveButtonText
    } = props;
    const auth = useAuthentication();
    const onLeaveSessionClick = useCallback(() => {
        auth.logout().then(() => {
            UtilService.deleteAllCookies();
            sessionStorage.clear();
            window.location.href = UtilService.unifiedLogoutSessionExpired(LocaleService.getStoredLanguage());
        });
    }, [auth]);

    return (
        <ModalNext
            isOpen={isOpen}
            shouldCloseOnOverlayClick={false}
            ariaLabelledby="sessionExpiryHeader"
            ariaDescribedby="sessionExpiryDescription"
            className={styles.modalContainer}
        >
            <ModalHeader title={<h2 id="sessionExpiryHeader" className={styles.diModalHeader}>{modalTitle}</h2>} />
            <ModalBody>
                <p id="sessionExpiryDescription" className={styles.diModalContent}>{modalDescription}</p>
            </ModalBody>
            <ModalFooter>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <Button
                        id="sessionPriButton"
                        className={styles.normalSpace}
                        style={{ marginLeft: '0px !important' }}
                        type="secondary"
                        onClick={() => {
                            onLeaveSessionClick();
                            onResolve();
                        }}
                    >
                        {leaveButtonText}
                    </Button>
                </div>
            </ModalFooter>
        </ModalNext>
    );
}

PIQModalPopup.propTypes = {
    isOpen: PropTypes.string.isRequired,
    modalTitle: PropTypes.string.isRequired,
    modalDescription: PropTypes.string.isRequired,
    leaveButtonText: PropTypes.string.isRequired,
    onResolve: PropTypes.func.isRequired
};

function PIQModalPopupModal(modalTitle, modalDescription, leaveButtonText) {
    ModalNextProvider.showModal(
        <PIQModalPopup
            modalTitle={modalTitle}
            modalDescription={modalDescription}
            leaveButtonText={leaveButtonText}
        />
    ).then((result) => {
        console.log(`Dialog closed: ${result}`);
        return result;
    }, _.noop);
}

export default PIQModalPopupModal;
